import * as React from 'react';
import {
  Button,
  Dialog, DialogActions, DialogTitle,
  Typography,
} from '@material-ui/core';

interface InvalidBarcodeDialogProps {
  onClose: () => void;
  showInvalidModal: boolean;
  barcode: string;
}

const InvalidBarcodeDialog: React.FC<InvalidBarcodeDialogProps> = ({
  showInvalidModal, onClose, barcode,
}) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      onClose={handleClose}
      open={showInvalidModal}
      fullWidth
      maxWidth="sm"
    >
      <>
        <DialogTitle>
          <Typography variant="overline">
            {`ERROR DURING SCANNING PROCESS - #${barcode}`}
          </Typography>
          <Typography variant="h5" id="dialog-header">{'Invalid barcode scan.'}</Typography>
          <Typography variant="body2" id="dialog-subHeader">{'Please rescan a valid barcode.'}</Typography>
        </DialogTitle>
        <DialogActions style={{ padding: '0 15px 19px' }}>
          <Button style={{ width: '85px', padding: '5px 25px' }} color="secondary" variant="contained" onClick={handleClose}>{'OKAY'}</Button>
        </DialogActions>
      </>
    </Dialog>
  );
};

export default InvalidBarcodeDialog;
